module.exports = __webpack_public_path__ + "static/media/242 Park - Exterior Site 1.f905fff5.jpg";